import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Row, Col, Card, Form, Input, Checkbox } from 'antd'

const FormItem = Form.Item

const JoinUsMainExperiencePositionStep = ({ form, profile }) => {
  const { getFieldDecorator } = form

  if (isEmpty(profile)) {
    return (
      <React.Fragment>
        <Card title="Main Experience" type="inner">
          <Row>
            <Col span={4}>
              <FormItem
                label="NGOs"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('checkboxNGOs', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
              <FormItem
                label="UNs"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('checkboxUNs', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
              <FormItem
                label="Donors"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('checkboxDonors', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
              <FormItem
                label="Consultancy Group"
                labelCol={{ span: 22 }}
                wrapperCol={{ span: 2 }}
              >
                {getFieldDecorator('checkboxConsultancyGroup', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem
                label="Names"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
              >
                {getFieldDecorator(
                  'NGOs',
                  {}
                )(<Input placeholder="Enter names separated by commas" />)}
              </FormItem>
              <FormItem
                label="Names"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
              >
                {getFieldDecorator(
                  'UNs',
                  {}
                )(<Input placeholder="Enter names separated by commas" />)}
              </FormItem>
              <FormItem
                label="Names"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
              >
                {getFieldDecorator(
                  'donors',
                  {}
                )(<Input placeholder="Enter names separated by commas" />)}
              </FormItem>
              <FormItem
                label="Names"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
              >
                {getFieldDecorator(
                  'consultant',
                  {}
                )(<Input placeholder="Enter names separated by commas" />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        <Card title="Current Position" type="inner">
          <FormItem
            label="Agency"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator(
              'agency',
              {}
            )(<Input placeholder="Enter names separated by commas" />)}
          </FormItem>
          <FormItem
            label="Position"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator(
              'position',
              {}
            )(<Input placeholder="Enter names separated by commas" />)}
          </FormItem>
        </Card>
        <Card title="Language Perfectly Spoken and Written" type="inner">
          <Row style={{ marginLeft: '-20px' }}>
            <Col span={3}>
              <FormItem
                label="English"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('English', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Swahili"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Swahili', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Arabic"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Arabic', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3} offset={1}>
              <FormItem
                label="Portuguese"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Portuguese', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="French"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('French', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Spanish"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Spanish', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
            <Col span={3}>
              <FormItem
                label="Somali"
                labelCol={{ span: 20 }}
                wrapperCol={{ span: 4 }}
              >
                {getFieldDecorator('Somali', {
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormItem
                label="Others"
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                {getFieldDecorator(
                  'otherlang',
                  {}
                )(
                  <Input placeholder="Enter other languages separated by commas" />
                )}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Card title="Main Experience" type="inner">
        <Row>
          <Col span={4}>
            <FormItem
              label="NGOs"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('checkboxNGOs', {
                initialValue: profile.checkboxNGOs === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
            <FormItem
              label="UNs"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('checkboxUNs', {
                initialValue: profile.checkboxUNs === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
            <FormItem
              label="Donors"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('checkboxDonors', {
                initialValue: profile.checkboxDonors === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
            <FormItem
              label="Consultancy Group"
              labelCol={{ span: 22 }}
              wrapperCol={{ span: 2 }}
            >
              {getFieldDecorator('checkboxConsultancyGroup', {
                initialValue:
                  profile.checkboxConsultancyGroup === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={20}>
            <FormItem
              label="Names"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator('NGOs', {
                initialValue: profile.NGOs,
              })(<Input placeholder="Enter names separated by commas" />)}
            </FormItem>
            <FormItem
              label="Names"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator('UNs', {
                initialValue: profile.UNs,
              })(<Input placeholder="Enter names separated by commas" />)}
            </FormItem>
            <FormItem
              label="Names"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator('donors', {
                initialValue: profile.donors,
              })(<Input placeholder="Enter names separated by commas" />)}
            </FormItem>
            <FormItem
              label="Names"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator('consultant', {
                initialValue: profile.consultant,
              })(<Input placeholder="Enter names separated by commas" />)}
            </FormItem>
          </Col>
        </Row>
      </Card>
      <Card title="Current Position" type="inner">
        <FormItem
          label="Agency"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('agency', {
            initialValue: profile.agency,
          })(<Input placeholder="Enter names separated by commas" />)}
        </FormItem>
        <FormItem
          label="Position"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('position', {
            initialValue: profile.position,
          })(
            <Input
              placeholder="Enter names separated by commas"
              disabled={true}
            />
          )}
        </FormItem>
      </Card>
      <Card title="Language Perfectly Spoken and Written" type="inner">
        <Row style={{ marginLeft: '-20px' }}>
          <Col span={3}>
            <FormItem
              label="English"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('English', {
                initialValue: profile.English === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Swahili"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Swahili', {
                initialValue: profile.Swahili === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Arabic"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Arabic', {
                initialValue: profile.Arabic === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3} offset={1}>
            <FormItem
              label="Portuguese"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Portuguese', {
                initialValue: profile.Portuguese === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="French"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('French', {
                initialValue: profile.French === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Spanish"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Spanish', {
                initialValue: profile.Spanish === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem
              label="Somali"
              labelCol={{ span: 20 }}
              wrapperCol={{ span: 4 }}
            >
              {getFieldDecorator('Somali', {
                initialValue: profile.Somali === 'OK' ? true : false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem
              label="Others"
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              {getFieldDecorator('otherlang', {
                initialValue: profile.otherlang,
              })(
                <Input placeholder="Enter other languages separated by commas" />
              )}
            </FormItem>
          </Col>
        </Row>
      </Card>
    </React.Fragment>
  )
}

export default JoinUsMainExperiencePositionStep
